import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Header = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: 4,
}));

export const Message = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: 0.1,
  color: colors.gray600,
}));

export const Title = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: 24,
  fontWeight: 500,
  lineHeight: "32px",
}));

export const CardWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 24,
  marginTop: 24,
  marginBottom: 32,
}));

const styles = makeStyles(() => ({
  modal: {
    maxWidth: "676px !important",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    "& > label": {
      marginBottom: 0,
      marginRight: 8,
    },
  },
}));

export default styles;
